import * as React from 'react';

import {getChannelIconFromInt} from '../../../channels/helpers';

import {ItemWithIcon} from './item-with-icon';
import {TruncatedItems} from './truncated-items';

export type ChannelType = {
    id: number;
    name: string;
};

type Props = {
    value: ChannelType[];
};

export function Channel(props: Props) {
    return (
        // @ts-expect-error
        <TruncatedItems
            value={props.value}
            isTokenized={true}
            renderRow={(channel: ChannelType) => {
                return (
                    <ItemWithIcon
                        key={channel.id}
                        icon={getChannelIconFromInt(channel.id)}
                        text={channel.name}
                    />
                );
            }}
        />
    );
}
